import React from "react";
import SelectField from "../../../components/forms/SelectField";

const pageSizeOptions = [
  { value: "us-trade", label: "US Trade (6 x 9 in)" }
];

const totalPagesOptions = [
  { value: "32", label: "32 Pages" }
];

export default function PageOptions({
  wordsPerPage = 50,
  onPageChange,
  onContentChange,
  // onPageSizeChange is not needed with Formik integration
  pageSize = "us-trade", // For display only - Formik controls the actual value
  isWordsPerPageDisabled = true
}) {
  // Create words per page options based on the current value
  const wordsPerPageOptions = [
    { value: wordsPerPage.toString(), label: `${wordsPerPage} Words` }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Words per Page
        </label>
        <SelectField
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
            isWordsPerPageDisabled ? "bg-gray-100 cursor-not-allowed" : ""
          }`}
          label=""
          name="wordsPerPage"
          options={wordsPerPageOptions}
          value={wordsPerPage.toString()}
          onChange={(e) => onPageChange?.(e.target.value)}
          disabled={isWordsPerPageDisabled}
        />
      </div>
      
      <div>
        <SelectField
          label="Total Pages"
          name="totalPages"
          options={totalPagesOptions}
          value="32"
          disabled={true}
          className="bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div>
        <SelectField
          label="Page Size"
          name="pageSize"
          options={pageSizeOptions}
          /* Remove value prop to let Formik control it completely */
        />
      </div>
    </div>
  );
}